import {Box, Paper, Tab, Tabs, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import NewsPlayground from "../componenets/playgroundTabs/NewsPlayground";
import Loader from "../componenets/Loader";
import ArticlePlayground from "../componenets/playgroundTabs/ArticlePlayground";
import {getCompanies} from "../services/CompanyService";
import BrandingBannerPlayground from "../componenets/playgroundTabs/BrandingBannerPlayground";

const Playground = () => {

  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    getCompanies()
        .then(res => setCompanies(res.data))
  }, []);

  const handleChange = (event, val) => {
    setCurrentTab(val);
  };

  const tabLabels = ["News", "Weekly Digest", "Articles", "Single Post", "Branding Banner"];

  return (
      <>
        <Loader loading={loading}/>

        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3, mb: 3 }}>
          <Typography sx={{
            fontWeight: 700,
            fontSize: { md: "32px", xs: "24px" },
            lineHeight: { md: "40px", xs: "32px" }
          }} color="primary.main">
            Playground
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Test and generate content manually
          </Typography>
        </Box>

        {/* Category Tabs */}
        <Paper sx={{ mb: 3 }} elevation={1}>
          <Tabs
            value={currentTab}
            onChange={handleChange}
            aria-label="playground tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabLabels.map((label, index) => (
              <Tab key={index} value={index} label={label} sx={{ textTransform: "none" }} />
            ))}
          </Tabs>
        </Paper>

        {/* Content Area */}
        <Paper sx={{ p: 3 }} elevation={1}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.75rem" }}>
              {tabLabels[currentTab]} Configuration
            </Typography>
          </Box>

          {currentTab === 0 && <NewsPlayground type={"NEWS"} setLoading={setLoading} companies={companies}/>}
          {currentTab === 1 && <NewsPlayground type={"WEEKLY_DIGEST"} setLoading={setLoading} companies={companies}/>}
          {currentTab === 2 && <ArticlePlayground type={"ARTICLE"} setLoading={setLoading} companies={companies}/>}
          {currentTab === 3 && <ArticlePlayground type={"SINGLE_POST"} setLoading={setLoading} companies={companies}/>}
          {currentTab === 4 && <BrandingBannerPlayground setLoading={setLoading} companies={companies}/>}
        </Paper>
      </>
  )
};

export default Playground;
